import { IdentifiableDto } from "./identifiable.dto";

export class MatchedLeadsProductHiringAreaDto extends IdentifiableDto {
    name!: string;
    lat!: number;
    lng!: number;
    radius: number;
}